import React from 'react';

import { Tabs } from '@vw-marketing/us-components';

import { onVWBasicModeChangeEvent } from '../../tagging/tagging-helpers';
import { StyledTab } from './styled';
import { TabContent } from '../tabContent';
import { useMaintenanceContext } from '../../hooks/use-maintenance-context';
import { useStore } from '../../hooks-store/store';
import { useTrackingManager } from '../../hooks/use-tracking-manager';

interface TabSelectorProps {
  onSelect: (tab: 'modelDetails' | 'vin') => void;
  vinApiError?: string | null;
  apiConfig: string;
  deeplinkModelYear?: string;
}

export const TabSelector = ({
  onSelect,
  vinApiError,
  apiConfig,
  deeplinkModelYear,
}: TabSelectorProps) => {
  const { translationHandler } = useMaintenanceContext();
  const trackingManager = useTrackingManager();

  const [store] = useStore();
  const { form } = store;

  const onTabChange = (index: number) => {
    if (index === 0) {
      onSelect('modelDetails');
      handleTracking('Model Details');
    } else {
      handleTracking('VIN');
      onSelect('vin');
    }
  };

  const handleTracking = (mode: 'Model Details' | 'VIN') => {
    onVWBasicModeChangeEvent(
      trackingManager,
      {
        Type: 'Button',
        Name: mode,
        ItemCount: 2,
        ItemPosition: mode === 'Model Details' ? 1 : 2,
      },
      mode,
    );
  };

  return (
    <StyledTab>
      <Tabs
        variant="step navigation"
        idPrefix="formTab"
        onChange={onTabChange}
        defaultIndex={form?.vin || form.selectedTab === 'vin' ? 1 : 0}
      >
        {{
          title: translationHandler('form.tab.model'),
          content: (
            <TabContent
              vinApiError={vinApiError}
              apiConfig={apiConfig}
              deeplinkModelYear={deeplinkModelYear}
            />
          ),
          key: 'modelDetails',
        }}
        {{
          title: translationHandler('form.tab.vin'),
          content: (
            <TabContent
              vinApiError={vinApiError}
              apiConfig={apiConfig}
              deeplinkModelYear={deeplinkModelYear}
            />
          ),
          key: 'vin',
        }}
      </Tabs>
    </StyledTab>
  );
};
